export class Shapes {
  public file_pointShp: File;
  public file_pointShx: File;
  public file_pointPrj: File;
  public file_pointDbf: File;
  public file_lineShp: File;
  public file_lineShx: File;
  public file_linePrj: File;
  public file_lineDbf: File;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/models/shapes.model.ts